<template>
    <div class="container">
        <div class="row">
            <div class="main-content col-12 col-md-12 col-lg-12 mx-auto">
                <div class="account-box">
                    <div class="box bos-d">
                        <div v-if="isSuccess">
                            <img src=" /assets/img/loader-login.svg" />
                            <span>در حال احراز هویت ...</span>
                        </div> 
                        <p v-if="isSuccess &&  message != ''" class="top-right sucess">احراز هویت موفق</p>
                        <p v-if="!isSuccess &&  message != ''" class="top-right unsucess">احراز هویت ناموفق</p>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import { httpPromise } from "../../../module/httpUtility.js";
  
    export default {
        data() {
            return {
                message: '',
                isSuccess: true
            }
        },
        mounted() { 
            httpPromise(this, '/v1/Identity/Account/LoginWithUrl', 'get', { RefId: this.$route.query.RefId },
                response => {
                    localStorage.setItem('accessToken', response.data.Value.Token);
                    this.$store.commit('setUserFullName', response.data.Value.UserFullName);
                    var path = IsNullOrEmptyString(this.$route.query.returnUrl) ? '/' : this.$route.query.returnUrl;
                    this.message = response.data.Message;
                    this.isSuccess = true;
                    window.location.href = path;
                },
                response => {
                    this.message = response.data.Message;
                    this.isSuccess = false;
                    
                });
        },
        beforeMount: function () {
            createPageTitle('ورود به سیستم');
        } 
    }
</script>

<style scoped>
    .bos-d img {
        width: 80px;
    }

    .bos-d {
        margin: 10px;
        display: flex;
        justify-content: center;
        align-items: center;
        flex-direction: column;
    }

        .bos-d .top-right {
            border: 1px solid;
            padding: 10px;
            margin: 25px;
        }

        .bos-d .sucess {
            border-color: #81c42c;
            color: #81c42c;
        }

        .bos-d .unsucess {
            border-color: #ff0000;
            color: #ff0000;
        }
</style>